import { RawStatisticsItem } from '../types';

export function extractDataArray(response: any): RawStatisticsItem[] {
  if (!response) {
    return [];
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  if (Array.isArray(response)) {
    return response;
  }

  return [];
}
